<template>
  <div class="container">
    <va-select v-model="selected" :options="consents" textBy="consentTitle"></va-select>
    <consent-grid></consent-grid>
  </div>
</template>

<script>
import ConsentGrid from './FormConsentGrid.vue'

export default {
  props: ['consents'],
  data () {
    return {
      selected: '',
    }
  },
  components: {
    'consent-grid': ConsentGrid,
  },
}
</script>
